if (window.location.href.indexOf("/products/") > -1) {
    (function ($) {

        $('.readmore').click(function (event) {
          event.preventDefault();
          var descriptionFull = document.querySelector('.product-description-full');
          descriptionFull.style.display = 'block';
          var descriptionShort = document.querySelector('.product-description-short');
          descriptionShort.style.display = 'none';
        });

        $('.readless').click(function (event) {
        
          var descriptionFull = document.querySelector('.product-description-full');
          descriptionFull.style.display = 'none';
          var descriptionShort = document.querySelector('.product-description-short');
          descriptionShort.style.display = 'block';
        });

        document.addEventListener("DOMContentLoaded", function (event) {
            var test = "";
            $($('.product-single__description').find('h6, h5,h4,h3').get().reverse()).each(function (i) {
    
                var tabName = $(this).text();
    
                tabContent = '';
    
                    //check if h6 has text inside
                if ($(this).text() != '') {
                        //hide h6
    
                    $(this).hide();
                        //combine content between H6 elements
                    $(this).nextUntil('h6,h5,h4,h3').not(".readless").each(function () {
                        tabContent = tabContent + this.outerHTML;
                            //hide content
                        $(this).hide();
    
    
                    });
                        //generate tab HTML
                        // console.log(i);
                    var test = ('<div class="product-single__accordion__item-wrap"><input type="checkbox" id="acc-unique-' + [i] + '"/><label class="product-single__accordion__title js-unique-trigger" for="acc-unique-' + [i] + '"><h4 class="product-single__accordion__title-text">' + tabName + '</h4></label><div class="product-single__accordion__item js-unique-info">' + tabContent + '</div></div>');
                    $('.js-accordion').prepend(test);
                        //console.log(i);
                        //console.log(test);
                } else {
                    //hide empty H6
                    $(this).hide();
                }
            });
            $('.js-accordion').prepend($('.description-wrap'));
        });

        BOLD.options.app.on('option_changed', function(data)
        {
          $('.total_extra_money').remove();
          setTimeout(function()
          {
            $('.total_extra_money').remove();
            var extrapriceselector = $('input[data-property-name="_boldVariantPrices"]');
            if (extrapriceselector.length ) 
            {
              var extrapriceval = extrapriceselector.val();
              if( extrapriceval != "" || extrapriceval != null || typeof extrapriceval != 'undefined')
              {
               const extrapricearray = extrapriceval.split(',');
               const totalextra = extrapricearray.reduce((a, b) => Number(a) + Number(b), 0);
               if(totalextra !="" && totalextra > 0)
               {
                 var html = `<div class="total_extra_money">Total Extras : <span>${Shopify.formatMoney(totalextra)}</span></div>`;
                 $( ".bold_option_total" ).prepend(html);
               }
              }
            }
          },1000);
        });

        
        $(document).on('change', `.bold_option_swatch .bold_option_element .bold_option_value_element input[type="checkbox"]`, function(e) 
        {
          var finishcolorname = $(this).val();
          var selectorF = $(`.gallery-navigation--scroller button img[alt="${finishcolorname}"]`);
          if(selectorF.length)
          {
             selectorF.parent('button').trigger('click');
          }
        });

        $(document).on('click', 'a[href^="#"]', function(e) {
            // target element id
            var id = $(this).attr('href');
        
            // target element
            var $id = $(id);
            if ($id.length === 0) {
                return;
            }
        
            // prevent standard hash navigation (avoid blinking in IE)
            e.preventDefault();
        
            // top position relative to the document
            var pos = $id.offset().top - 200;
        
            // animated top scrolling
            $('body, html').animate({scrollTop: pos});
        });
        $( ".product-form--atc" ).append( $( ".rfq-btn-0" ) );
    }(jQuery))
}